export const emailConstants = {
 
   ADD_EMAIL_REQUEST:      	               'ADD_EMAIL_REQUEST',
   ADD_EMAIL_SUCCESS:      	               'ADD_EMAIL_SUCCESS',
   ADD_EMAIL_FAILURE:      	               'ADD_EMAIL_FAILURE',
   GET_EMAIL_DETAILS_REQUEST:                'GET_EMAIL_DETAILS_REQUEST',
   GET_EMAIL_DETAILS_SUCCESS:               'GET_EMAIL_DETAILS_SUCCESS',
   GET_EMAIL_DETAILS_FAILURE:               'GET_EMAIL_DETAILS_FAILURE',
   DELETE_SMTP_REQUEST:                      'DELETE_SMTP_REQUEST',
   DELETE_SMTP_SUCCESS:                      'DELETE_SMTP_SUCCESS',
   DELETE_SMTP_FAILURE: 	                  'DELETE_SMTP_FAILURE',
   GET_EMAIL_TEMPELATE_REQUEST:              'GET_EMAIL_TEMPELATE_REQUEST',
   GET_EMAIL_TEMPELATE_SUCCESS:              'GET_EMAIL_TEMPELATE_SUCCESS',
   GET_EMAIL_TEMPELATE_FAILURE:              'GET_EMAIL_TEMPELATE_FAILURE',
   GET_EMAIL_TEMPELATE_DETAILS_REQUEST:      'GET_EMAIL_TEMPELATE_DETAILS_REQUEST',
   GET_EMAIL_TEMPELATE_DETAILS__SUCCESS:     'GET_EMAIL_TEMPELATE_DETAILS__SUCCESS',
   GET_EMAIL_TEMPELATE_DETAILS_FAILURE:      'GET_EMAIL_TEMPELATE_DETAILS_FAILURE',
   UPDATE_EMAIL_TEMPELATE_DETAILS_REQUEST:   'UPDATE_EMAIL_TEMPELATE_DETAILS_REQUEST',
   UPDATE_EMAIL_TEMPELATE_DETAILS__SUCCESS:  'UPDATE_EMAIL_TEMPELATE_DETAILS__SUCCESS',
   UPDATE_EMAIL_TEMPELATE_DETAILS_FAILURE:   'UPDATE_EMAIL_TEMPELATE_DETAILS_FAILURE',
   TEST_MAIL_REQUEST:                        'TEST_MAIL_REQUEST',
   TEST_MAIL_SUCCESS:                        'TEST_MAIL_SUCCESS',
   TEST_MAIL_FAILURE:                        'TEST_MAIL_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/emailConstants.js